import React from "react"
import { FileItemTooltip } from "./FileUploadItemTooltip"
import { TypedValidationError } from "./expiringFiles"
import AlertTitle from "@mui/material/AlertTitle"
import { Alert, styled, Typography } from "@mui/material"
import { Severity } from "./FileUploadItemTooltip"

interface FileItemTooltipTitleProps {
  severity: Severity
  description: string
  message: string
}

const FileItemTooltipTitle = ({ description, severity, message }: FileItemTooltipTitleProps) => {
  return (
    <Alert severity={severity} className="file-upload-tooltip" sx={{ backgroundColor: "#FFFFFF" }}>
      <AlertTitle>{description}</AlertTitle>
      <Typography
        sx={{ font: "normal normal normal 10px/16px Inter", letterSpacing: "0px", color: "#42526E" }}
      >
        {message}
      </Typography>
    </Alert>
  )
}

const FileDescription = styled("span")({
  whiteSpace: "nowrap",
  marginLeft: "8px"
})

interface ErrorWithPopupProps {
  severity: Severity
  validationError: TypedValidationError
}

const ErrorWithPopup = ({ severity, validationError }: ErrorWithPopupProps) => {
  return (
    <FileItemTooltip
      arrow
      severity={severity}
      title={
        <FileItemTooltipTitle
          severity={severity}
          description={validationError.description}
          message={validationError.message}
        />
      }
    >
      <FileDescription>{validationError.description}</FileDescription>
    </FileItemTooltip>
  )
}

export default ErrorWithPopup
